import { useAtomValue } from 'jotai/index';
import { useEffect, useState } from 'react';
import { DocCompareChunkFinderChunk } from '~/api/def/endpoints/docCompare/docCompareChunkFinderEndpoint';
import { FundGetData } from '~/api/def/endpoints/fundEndpoint';
import { globalSearchStringAtom } from '~/atoms/globalSearch';
import { SearchResult } from '~/components/ui/globalSearch/SearchResult';
import {
  searchResultHighligtsObject,
  SearchResultParsed,
} from '~/components/ui/globalSearch/searchResultHighligts';

// Extend the DocCompareChunkFinderChunk interface to include the _originalFund property
interface ExtendedDocCompareChunkFinderChunk
  extends DocCompareChunkFinderChunk {
  _originalFund?: FundGetData;
}

export type SearchResultProps = {
  result: ExtendedDocCompareChunkFinderChunk;
  onClose?: () => void;
};
export const SearchResultContainer = ({
  result,
  onClose,
}: SearchResultProps) => {
  const search = useAtomValue(globalSearchStringAtom);
  const [resultParsed, setResultParsed] = useState<
    SearchResultParsed | undefined
  >(undefined);
  useEffect(() => {
    if (result) {
      setResultParsed(searchResultHighligtsObject(search, result.text, 4));
    } else {
      setResultParsed(undefined);
    }
  }, [result]);

  return (
    <SearchResult
      result={result}
      resultParsed={resultParsed}
      onClose={onClose}
    />
  );
};
